import React from 'react';
import AppleIcon from '@material-ui/icons/Apple';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { APP_LOGIN_URL } from '../constants';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import ShopIcon from '@material-ui/icons/Shop';
import { useLanguage } from '../contexts/LanguageContext';

const COPY = {
  en: {
    titleIntro: 'Making shipping people',
    titleA: 'Decision-makers,',
    titleB: 'not data clerks.',
    talk: 'Talk to us',
    dlLabel: 'ACCESS FLEETGO · WEB / iOS / ANDROID',
    dlLoginK: 'WEB ACCESS', dlLoginV: 'Login FleetGO',
    dlIosK: 'SEARCH IN APP STORE', dlIosV: 'FleetGO',
    dlAndroidK: 'GET IT ON', dlAndroidV: 'Google\u00A0Play',
    product: 'FleetGo · Voyage estimation workspace',
    status: 'Product preview',
  },
  zh: {
    titleA: '让航运人成为决策者，',
    titleB: '而不是录入员。',
    talk: '联系我们',
    dlLabel: '使用 FLEETGO · 网页 / iOS / ANDROID',
    dlLoginK: '网页端', dlLoginV: '登录 FleetGO',
    dlIosK: '在 APP STORE 搜索', dlIosV: 'FleetGO',
    dlAndroidK: '在以下平台获取', dlAndroidV: 'Google Play',
    product: 'FleetGo · 航次估算工作空间',
    status: '产品预览',
  },
  'zh-TW': {
    titleA: '讓航運人成為決策者，',
    titleB: '而不是錄入員。',
    talk: '聯絡我們',
    dlLabel: '使用 FLEETGO · 網頁 / iOS / ANDROID',
    dlLoginK: '網頁端', dlLoginV: '登入 FleetGO',
    dlIosK: '在 APP STORE 搜尋', dlIosV: 'FleetGO',
    dlAndroidK: '在以下平台取得', dlAndroidV: 'Google Play',
    product: 'FleetGo · 航次估算工作空間',
    status: '產品預覽',
  },
  fr: {
    titleA: 'Faire des marins des décideurs,',
    titleB: 'pas des opérateurs de saisie.',
    talk: 'Nous contacter',
    dlLabel: 'ACCÉDER À FLEETGO · WEB / iOS / ANDROID',
    dlLoginK: 'ACCÈS WEB', dlLoginV: 'Connexion FleetGO',
    dlIosK: "RECHERCHER DANS L'APP STORE", dlIosV: 'FleetGO',
    dlAndroidK: 'DISPONIBLE SUR', dlAndroidV: 'Google\u00A0Play',
    product: "FleetGo · Espace d'estimation de voyage",
    status: 'Aperçu produit',
  },
  de: {
    titleA: 'Schifffahrtsteams entscheiden,',
    titleB: 'statt Daten einzugeben.',
    talk: 'Kontakt',
    dlLabel: 'FLEETGO NUTZEN · WEB / iOS / ANDROID',
    dlLoginK: 'WEB-ZUGANG', dlLoginV: 'FleetGO anmelden',
    dlIosK: 'IM APP STORE SUCHEN', dlIosV: 'FleetGO',
    dlAndroidK: 'ERHÄLTLICH BEI', dlAndroidV: 'Google\u00A0Play',
    product: 'FleetGo · Reise-Kalkulation',
    status: 'Produktvorschau',
  },
  ja: {
    titleA: '海運の現場を意思決定者に。',
    titleB: '入力作業者ではなく。',
    talk: '相談する',
    dlLabel: 'FLEETGO にアクセス · WEB / iOS / ANDROID',
    dlLoginK: 'WEB', dlLoginV: 'FleetGO ログイン',
    dlIosK: 'APP STORE で検索', dlIosV: 'FleetGO',
    dlAndroidK: '以下で入手', dlAndroidV: 'Google Play',
    product: 'FleetGo · 航海見積ワークスペース',
    status: '製品プレビュー',
  },
  ko: {
    titleA: '해운 실무자는 의사결정자입니다.',
    titleB: '데이터 입력자가 아닙니다.',
    talk: '문의하기',
    dlLabel: 'FLEETGO 접속 · WEB / iOS / ANDROID',
    dlLoginK: '웹', dlLoginV: 'FleetGO 로그인',
    dlIosK: 'APP STORE에서 검색', dlIosV: 'FleetGO',
    dlAndroidK: '다음에서 받기', dlAndroidV: 'Google Play',
    product: 'FleetGo · 항차 견적 워크스페이스',
    status: '제품 미리보기',
  },
  ar: {
    titleA: 'لنجعل العاملين في الشحن صُنّاع قرار،',
    titleB: 'لا مدخلي بيانات.',
    talk: 'تواصل معنا',
    dlLabel: 'استخدم FLEETGO · الويب / iOS / ANDROID',
    dlLoginK: 'الويب', dlLoginV: 'تسجيل دخول FleetGO',
    dlIosK: 'ابحث في APP STORE', dlIosV: 'FleetGO',
    dlAndroidK: 'احصل عليه من', dlAndroidV: 'Google Play',
    product: 'FleetGo · مساحة تقدير الرحلات',
    status: 'معاينة المنتج',
  },
};

const SHIP_HIT_AREA = [
  [0.43, 0.77], [0.43, 0.61], [0.51, 0.49], [0.59, 0.36],
  [0.68, 0.25], [0.81, 0.19], [0.89, 0.27], [0.89, 0.43],
  [0.81, 0.56], [0.68, 0.68], [0.55, 0.79],
];
const SEA_INTERACTION_START_X = 0.5;

function isPointInsidePolygon(x, y, polygon) {
  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const [xi, yi] = polygon[i];
    const [xj, yj] = polygon[j];
    const crossesEdge = ((yi > y) !== (yj > y))
      && (x < ((xj - xi) * (y - yi)) / (yj - yi) + xi);

    if (crossesEdge) inside = !inside;
  }

  return inside;
}

function Home() {
  const { language } = useLanguage();
  const t = COPY[language] || COPY.en;

  const handleVisualPointerMove = (event) => {
    if (event.pointerType === 'touch') return;

    const visual = event.currentTarget;
    const bounds = visual.getBoundingClientRect();
    const x = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
    const y = Math.min(1, Math.max(0, (event.clientY - bounds.top) / bounds.height));

    const isOverShip = isPointInsidePolygon(x, y, SHIP_HIT_AREA);

    visual.style.setProperty('--pointer-x', `${x * 100}%`);
    visual.style.setProperty('--pointer-y', `${y * 100}%`);
    visual.dataset.hoverZone = isOverShip
      ? 'ship'
      : x >= SEA_INTERACTION_START_X
        ? 'sea'
        : 'idle';
  };

  const handleVisualPointerLeave = (event) => {
    event.currentTarget.dataset.hoverZone = 'idle';
  };

  return (
    <section id="home" className="ed-hero">
      <div className="ed-container">
        <div className="ed-hero-grid">
          <div className="ed-hero-copy">
            <h1 className="ed-hero-title">
              {t.titleIntro && <span className="intro">{t.titleIntro}</span>}
              <span>{t.titleA}</span>
              <span className="accent">{t.titleB}</span>
            </h1>

            <div className="ed-hero-support">
              <div className="ed-hero-downloads">
                <div className="ed-dl-label">{t.dlLabel}</div>
                <div className="ed-dl-row">
                  <a
                    className="ed-dl-card ed-dl-card-login"
                    href={APP_LOGIN_URL}
                    aria-label={t.dlLoginV}
                  >
                    <span className="ed-dl-ico"><ExitToAppIcon aria-hidden="true" /></span>
                    <span className="ed-dl-meta">
                      <span className="dl-k">{t.dlLoginK}</span>
                      <span className="dl-v">{t.dlLoginV}</span>
                    </span>
                  </a>
                  <div
                    className="ed-dl-card ed-dl-card-ios"
                    tabIndex="0"
                    aria-label="Search for FleetGO in the App Store"
                  >
                    <span className="ed-dl-ico"><AppleIcon aria-hidden="true" /></span>
                    <span className="ed-dl-meta">
                      <span className="dl-k">{t.dlIosK}</span>
                      <span className="dl-v">{t.dlIosV}</span>
                    </span>
                  </div>
                  <a
                    className="ed-dl-card ed-dl-card-android"
                    href="https://public-hp-assets.s3.ap-northeast-1.amazonaws.com/app-release.apk"
                    aria-label="Download Android app"
                  >
                    <span className="ed-dl-ico"><ShopIcon aria-hidden="true" /></span>
                    <span className="ed-dl-meta">
                      <span className="dl-k">{t.dlAndroidK}</span>
                      <span className="dl-v">{t.dlAndroidV}</span>
                    </span>
                  </a>
                </div>
              </div>

              <div className="ed-hero-actions">
                <a className="ed-hero-cta" href="mailto:service@fisfleetgo.com">{t.talk}</a>
                <a className="ed-hero-mail" href="mailto:service@fisfleetgo.com">
                  <MailOutlineIcon className="ed-hero-mail-icon" aria-hidden="true" />
                  <span>service@fisfleetgo.com</span>
                </a>
              </div>
            </div>
          </div>

          <figure
            className="ed-visual-image"
            aria-label="Technical line drawing of a geared dry-bulk vessel with AI-driven voyage, commercial, compliance, and financial capabilities"
            data-hover-zone="idle"
            onPointerMove={handleVisualPointerMove}
            onPointerLeave={handleVisualPointerLeave}
          >
            <div className="ed-visual-image-frame">
              <img
                className="ed-visual-base-image"
                src="/images/editorial/fleetgo-ai-platform-hero-v4.jpg"
                alt=""
              />
              <div className="ed-visual-sea-motion" aria-hidden="true" />
              <img
                className="ed-visual-color-image"
                src="/images/editorial/fleetgo-ai-platform-hero-v3.jpg"
                alt=""
                aria-hidden="true"
              />
              <div className="ed-visual-ship-sheen" aria-hidden="true" />
              <div className="ed-visual-image-caption" aria-hidden="true">
                <span className="ed-hover-capability-slot">
                  <span className="ed-compliance-capabilities">
                    <span className="ed-ship-capability">EU compliance</span>
                    <span className="ed-ship-capability">Financial statement</span>
                  </span>
                  <span className="ed-ship-capabilities">
                    <span className="ed-ship-capability">Estimation</span>
                    <span className="ed-ship-capability">SOA</span>
                    <span className="ed-ship-capability">Freight</span>
                    <span className="ed-ship-capability">Laytime</span>
                    <span className="ed-ship-capability">Voyage task</span>
                  </span>
                  <span className="ed-sea-capabilities">
                    <span className="ed-sea-capability ed-sea-capability-weather">Weather forecast</span>
                    <span className="ed-sea-capability ed-sea-capability-routing">Routing suggestion</span>
                    <span className="ed-sea-capability ed-sea-capability-distance">Distance</span>
                    <span className="ed-sea-capability ed-sea-capability-fuel">Fuel optimization</span>
                  </span>
                </span>
                <span className="ed-visual-image-caption-base">
                  <span>AI DRIVEN</span>
                  <span className="ed-visual-image-caption-dot" />
                  <span>ALL IN ONE PLATFORM</span>
                </span>
              </div>
            </div>
          </figure>

        </div>
      </div>
    </section>
  );
}

export default Home;
